import React, { useState, useEffect } from "react";
import { getIdData } from "../../../lib/studentinfo";
import { updateData } from "../../../lib/profiles";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../usercontext";

export default function StudentProfileEdit() {
    const [classforLesson, setClassForLesson] = useState(9);
    const { profile, setProfile } = useAuth();
    const [name, setName] = useState();
    const [surname, setSurname] = useState();
    const [phone, setPhone] = useState();
    const [username, setUserName] = useState();
    const navigate = useNavigate();
    let { slug, type } = useParams();
    const [school, setSchool] = useState();
    const [graduate, setGraduate] = useState();
    const [gpa, setGpa] = useState();
    const [sat, setSat] = useState();
    const [stateTest, setStateTest] = useState();
    const [major, setMajor] = useState();
    const [career, setCareer] = useState();
    const [studentInfo, setStudentInfo] = useState();
    // NEW FIELDS
    const [fiveAdjectives, setFiveAdjectives] = useState();
    const [hsSchoolStatistics, setHsSchoolStatistics] = useState();
    const [topThreeColleges, setTopThreeColleges] = useState();
    const [lor, setLor] = useState();
    const [activities, setActivities] = useState();
    const [collegeEssay, setCollegeEssay] = useState();
    const [instructorNote, setInstructorNote] = useState();
    const [studentNote, setStudentNote] = useState();
    // NEW FIELDS
    const [meetLink, setMeetLink] = useState(profile.meetlink);
    const [folderLink, setFolderLink] = useState(profile.folderlink);

    const handleSubmit = async (e) => {
        e.preventDefault();
        //console.log("school",school);

        await updateData({
            id: profile.id,
            username: username,
            name: name,
            surname: surname,
            phone: phone,
            class: classforLesson,
            studentschool: school,
            graduateyear: graduate,
            gpa: gpa,
            satpsat: sat,
            statetest: stateTest,
            major: major,
            career: career,
            fiveAdjectives: fiveAdjectives,
            hsSchoolStatistics: hsSchoolStatistics,
            topThreeColleges: topThreeColleges,
            lor: lor,
            activities: activities,
            collegeEssay: collegeEssay,
            instructorNote: instructorNote,
            studentNote: studentNote,
            meetlink: meetLink,
            folderlink: folderLink,
        });
        navigate(-1);
        //navigate(`/student/student-profile`)
        //navigate(`/admin/admin-studentstep3/${slug}`);
    };

    async function GetData() {
        const info = await getIdData(profile.id);
        console.log("info", info);
        setStudentInfo(info);
        setName(info[0].name);
        setSurname(info[0].surname);
        setPhone(info[0].phone);
        setClassForLesson(info[0].class);
        setSchool(info[0].studentschool);
        setUserName(info[0].username);
        setGraduate(info[0].graduateyear);
        setGpa(info[0].gpa);
        setSat(info[0].satpsat);
        setStateTest(info[0].statetest);
        setMajor(info[0].major);
        setCareer(info[0].career);
        setFiveAdjectives(info[0].fiveAdjectives);
        setHsSchoolStatistics(info[0].hsSchoolStatistics);
        setTopThreeColleges(info[0].topThreeColleges);
        setLor(info[0].lor);
        setActivities(info[0].activities);
        setCollegeEssay(info[0].collegeEssay);
        setInstructorNote(info[0].instructorNote);
        setStudentNote(info[0].studentNote);
        setMeetLink(info[0].meetlink);
        setFolderLink(info[0].folderlink);
    }

    useEffect(() => {
        console.log("user", slug, type);
        GetData();
    }, []);

    return (
        <div className="col-12 update_parent_div">
            <div className="settings-widget profile-details">
                <div className="settings-menu p-0">
                    <div className="profile-heading">
                        <h3>
                            {type === "Add"
                                ? "Add Student"
                                : "Update your profile"}
                        </h3>
                    </div>
                    <div className="checkout-form personal-address add-course-info ">
                        <form role="form" onSubmit={handleSubmit}>
                            <div className="row mx-auto">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            value={name}
                                            onChange={(e) =>
                                                setName(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Name"
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Last Name
                                        </label>
                                        <input
                                            type="text"
                                            value={surname}
                                            onChange={(e) =>
                                                setSurname(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter LastName"
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Nick Name
                                        </label>
                                        <input
                                            name="text"
                                            value={username}
                                            onChange={(e) =>
                                                setUserName(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Nick Name"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Grade Level
                                        </label>
                                        <input
                                            type="number"
                                            value={classforLesson}
                                            onChange={(e) =>
                                                setClassForLesson(
                                                    e.target.value
                                                )
                                            }
                                            className="form-control"
                                            placeholder="Enter Grade Level"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Five Adjectives:five character trait
                                            adjectives that describe you the
                                            most
                                        </label>
                                        <input
                                            type="text"
                                            value={fiveAdjectives}
                                            onChange={(e) =>
                                                setFiveAdjectives(
                                                    e.target.value
                                                )
                                            }
                                            className="form-control"
                                            placeholder="Enter Five Adjectives:five character trait adjectives that
                      describe you the most"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            About my high school
                                        </label>
                                        <input
                                            type="text"
                                            value={hsSchoolStatistics}
                                            onChange={(e) =>
                                                setHsSchoolStatistics(
                                                    e.target.value
                                                )
                                            }
                                            className="form-control"
                                            placeholder="About my high school"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Phone
                                        </label>
                                        <input
                                            name="phone"
                                            placeholder="123-456-7890"
                                            pattern="(\d{3}[- ]?\d{3}[- ]?\d{4})"
                                            value={phone}
                                            onChange={(e) =>
                                                setPhone(e.target.value)
                                            }
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                {/*}
                        
                        <div className="col-12">
                          <div className="form-group">
                          <label className="form-control-label">
                              School 
                            </label>
                            <SchoolSelect value={school} setValue={setSchool}/>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label className="form-control-label">
                              Class 
                            </label>
                            <ClassForLessonSelect value={classforLesson}  setValue = {setClassForLesson} name={"ClassForLessonSelect"} />
                          </div>
                        </div>
                        */}

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Graduation year
                                        </label>
                                        <input
                                            name="text"
                                            value={graduate}
                                            onChange={(e) =>
                                                setGraduate(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Graduate Year"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            GPA: Weighted and unweighted GPA if
                                            known
                                        </label>
                                        <input
                                            name="text"
                                            value={gpa}
                                            onChange={(e) =>
                                                setGpa(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter GPA: Weighted and unweighted GPA if known"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            SAT and or PSAT scores and the date
                                            of testing
                                        </label>
                                        <textarea
                                            name="text"
                                            value={sat}
                                            onChange={(e) =>
                                                setSat(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Sat / Psat"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Practice SAT: Official practice SAT
                                            score and the date of testing
                                        </label>
                                        <textarea
                                            name="text"
                                            value={stateTest}
                                            onChange={(e) =>
                                                setStateTest(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Practice SAT: Official practice SAT score and the date of
                      testing"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Major: What do you want to study in
                                            college?
                                        </label>
                                        <input
                                            name="text"
                                            value={major}
                                            onChange={(e) =>
                                                setMajor(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Major: What do you want to study in college?"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Career: What do you want to do after
                                            college?
                                        </label>
                                        <input
                                            name="text"
                                            value={career}
                                            onChange={(e) =>
                                                setCareer(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Career: What do you want to do after college?"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Desired Colleges Top three college
                                            choices
                                        </label>
                                        <input
                                            name="text"
                                            value={topThreeColleges}
                                            onChange={(e) =>
                                                setTopThreeColleges(
                                                    e.target.value
                                                )
                                            }
                                            className="form-control"
                                            placeholder="Enter Top Desired Colleges Top three college choices"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Letter of Recommendation: Did you
                                            get one? It so, which teacher wrote
                                            it?
                                        </label>
                                        <input
                                            name="text"
                                            value={lor}
                                            onChange={(e) =>
                                                setLor(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Letter of Recommendation: Did you get one? It so, which
                      teacher wrote it?"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Activities: List all activities
                                            outside of your high school hours
                                        </label>
                                        <input
                                            name="text"
                                            value={activities}
                                            onChange={(e) =>
                                                setActivities(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Activities: List all activities outside of your high
                      school hours"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            College Essay: What progress have
                                            you made on your essay so far?{" "}
                                        </label>
                                        <input
                                            name="text"
                                            value={collegeEssay}
                                            onChange={(e) =>
                                                setCollegeEssay(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter College Essay: What progress have you made on your essay
                      so far?"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Counselor&apos;s Comment
                                        </label>
                                        <input
                                            name="text"
                                            value={instructorNote}
                                            onChange={(e) =>
                                                setInstructorNote(
                                                    e.target.value
                                                )
                                            }
                                            className="form-control"
                                            placeholder="Enter Counselor's Comment"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Student&apos;s Comment
                                        </label>
                                        <input
                                            name="text"
                                            value={studentNote}
                                            onChange={(e) =>
                                                setStudentNote(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter  Student's Comment"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Zoom Link
                                        </label>
                                        <input
                                            name="text"
                                            value={meetLink}
                                            onChange={(e) =>
                                                setMeetLink(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Zoom Link"
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-control-label">
                                            Folder Link
                                        </label>
                                        <input
                                            name="text"
                                            value={folderLink}
                                            onChange={(e) =>
                                                setFolderLink(e.target.value)
                                            }
                                            className="form-control"
                                            placeholder="Enter Folder Link"
                                        />
                                    </div>
                                </div>
                                <div className="update-profile d-flex flex-column gap-3 flex-sm-row justify-content-between">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        {type === "Add"
                                            ? "Next Step >>"
                                            : "Update"}
                                    </button>
                                    <button
                                        onClick={() => navigate(-1)}
                                        className="btn btn-black btn-sm update_page_cancel_btn"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
